import MediaQuery from 'react-responsive';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { calculateCellWidths } from 'streams/calculateCellWidths';
import { utils } from 'bastetjs';
import { globalStyles } from 'styles/globalStyles';
import _ from 'lodash';
let styles = {
  container: {
    display: 'flex',
    // float: 'left',
    width: '100%',
    padding: '32px 24px',
    WebkitTransform: 'translate3d(0,0,0)',
    fontWeight: '900',
    background: '#333',
    position: 'absolute',
    zIndex: '99',
    overflow: 'hidden',
  }
};


export class ReportHeaderComponent extends Component {
  static defaultProps = {
    cellWidths: [],
    columns: {},
    panelSettings: {},
  };

  render() {
    const { headerColor, columnsRatio, panelSettings, columns } =  this.props;
    styles.container.background = headerColor ? headerColor : styles.container.background;
    let cellWidths = this.props.cellWidths;
    let globalStyle = globalStyles.cell;

    globalStyle.textAlign =!_.isUndefined(panelSettings.center_columns)
      && panelSettings.center_columns == 1 ? 'center' : 'left';
    let percentage = 100/columns.length;

    return (
      <MediaQuery query='(min-width: 580px)'>
        <div style={styles.container} className='row'>
          {
            Object.keys(columns).map((col, index) => (
              <div className='cell'
                   // style={_.assign({}, globalStyle, haveResults ? { width: cellWidths[index] + 'px'} : {width: percentage + '%'}, cell.style || {})}
                   style={{
                     width: `${columnsRatio[col]}%`
                   }}
                   key={`header-cell-${col}`}>
                {columns[col]}
              </div>
            ))
          }
        </div>
      </MediaQuery>
    );
  }
}

export const ReportHeader = utils.connectStream({cellWidths:calculateCellWidths})(ReportHeaderComponent);



// WEBPACK FOOTER //
// ./components/report/ReportHeader.js